<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      show-save-button
      unit="话机管理"
      id-key="PhoneId"
      :data="data"
      form-label-width="110px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="话机编号" prop="PhoneCode">
              <el-input size="mini" v-model="data.PhoneCode" placeholder="请填写话机编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="话机号码" prop="PhoneNo">
              <el-input size="mini" v-model="data.PhoneNo" type="number" placeholder="请填写话机号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="通话时长上限" prop="UpperLimit">
              <el-input size="mini" v-model="data.UpperLimit" type="number" placeholder="请填写分钟数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="位置类型" prop="LocationType">
              <el-select size="mini" v-model="data.LocationType" style="width:100%;">
                <el-option value="室内" />
                <el-option value="室外" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="校区" prop="SchoolArea">
              <el-input size="mini" v-model="data.SchoolArea" placeholder="请填写校区"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="地点" prop="Place">
              <el-input size="mini" v-model="data.Place" placeholder="请填写地点"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="启用状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="连接状态" prop="ConnectStatus">
              <el-radio-group v-model="data.ConnectStatus">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">异常</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="适用校讯通" prop="EduToHome">
              <el-radio-group v-model="data.EduToHome">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="IMEI" prop="Imei">
              <!-- <el-input size="mini" v-model="data.Imei" readonly placeholder="" ></el-input> -->
              <span>{{data.Imei}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        PhoneId: 0,
        PhoneCode: "",
        PhoneNo: "",
        LocationType: "室内",
        SchoolArea: "",
        Place: "",
        UpperLimit: null,
        Status: 1,
        ConnectStatus: 1,
        Imei: "",
        EduToHome: 0, //适用校讯通 -  0:否 1:是
      },
      api: require("@/api/consume/phonemanage").default,
      isMB: this.$store.state.isMB,
      rules: {
        PhoneCode: [{ required: true, message: "请填写话机编号" }],
        PhoneNo: [{ required: true, message: "请填写话机号码" }],
        Place: [{ required: true, message: "请填写地点" }],
        UpperLimit: [
          { required: true, message: "请填写正整数" },
          { validator: this.$commonJs.validateRules.int },
        ],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {},
    onEditOpened() {},
  },
};
</script>
<style lang="scss">
</style>